/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="47.71"
        height="90.82"
        viewBox="0 0 47.71 90.82"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="transparent"
          stroke="#ffb81c"
          d="m23.48 66.63 12 22.54a27.6 27.6 0 0 0 11.15-13.55l-16-22.73Zm9.23-59.71c1 9.36-1.3 20.65-8.72 34.51-.38.69-.69 1.12-1 1.62-1.61 2.91-5.81 9.36-5.81 9.36h0l-16.16 22h0A26 26 0 0 0 5.9 84.72a27.44 27.44 0 0 0 4.41 5s6.9-11.4 13.66-24.03c2.27-4.53 4.65-9.22 6.59-12.77 4.83-9.66 7.59-16.28 8.59-20.8a37.61 37.61 0 0 0-1-18.72 19.22 19.22 0 0 0-5.8-9ZM22.58 42.17l.46.89-.78-1.52c-7.42-13.88-10.55-25.61-9.55-34.97h0A19.8 19.8 0 0 0 9.16 14a38 38 0 0 0-1 18.72c.64 3.54 4.83 13.23 7.42 19h0l.48 1.12M14.02 14h0l.33-.32a13.22 13.22 0 0 1 9-3.55 13.8 13.8 0 0 1 9 3.55l.43.42s.15-2.69.08-4.35-.28-3.6-.28-3.6l-.1-1.63a12.68 12.68 0 0 0-8.77-3.45 14.5 14.5 0 0 0-11 5.48"
          className="icon-stroke icon-accent"
          strokeWidth="2.144"
          strokeLinejoin="round"
          strokeLinecap="square"/>
      </svg>

    );
  }
}

Icon.displayName = 'AwarenessRibbonIcon';

export default Icon;
